module.exports = __webpack_public_path__ + "img/Lente_de_la_cámara_de_vídeo.d1e90de9.png";